/*
 * Copyright (c) ADS
 * Admin access allowlist for the "Manage Projects (Admin)" button.
 * Mirrors MiniCAD-FrontEnd/src/components/LeftMenu/ProjectInfo/internalUsers.js
 */

// ASI support users kept by exact address: @rand.com is not an admin domain.
const internalSupportUsers = new Set(['jhunt@rand.com', 'ppalacios@rand.com']);

// Whole-domain admin access (STRY0177874).
const adminDomains = new Set(['ads-pipe.com', 'adspipe.com', 'cultec.com']);

function isValidEmail(email) {
  return typeof email === 'string' && /^[^@\s]+@[^@\s]+$/.test(email);
}

function hasAdminAccess(email) {
  if (!isValidEmail(email)) return false;

  const normalizedEmail = email.toLowerCase();
  const domain = normalizedEmail.split('@')[1];
  return adminDomains.has(domain) || internalSupportUsers.has(normalizedEmail);
}

module.exports.hasAdminAccess = hasAdminAccess;



// WEBPACK FOOTER //
// ./src/components/LeftMenu/ProjectInfo/internalUsers.js